import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { OrganisationWithJobTitles } from '@src/api';
import { JobTitlesPipe } from '@src/app/shared/pipes';
import { ChatMemberModel, OrganisationJobTitleUI } from '@src/models';
import { ObjectId } from '@src/types/id';

/** TODO: не используется */
@Component({
  selector: 'app-list-item-chat-member',
  templateUrl: './list-item-chat-member.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-chat-member.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemChatMemberComponent {
  private readonly jobTitlesPipe = inject(JobTitlesPipe);

  @Input() set item(data: ChatMemberModel | undefined) {
    this.data = data as ChatMemberModel;
  }

  @Input() selectedId: ObjectId;
  @Input() loading?: boolean;

  data?: ChatMemberModel;

  get jobTitles(): OrganisationWithJobTitles[] | OrganisationJobTitleUI[] {
    let organisationJobTitles: OrganisationWithJobTitles[] | OrganisationJobTitleUI[] = [];

    // TODO: refactoring
    if (this.data && this.data.organisationJobTitles) {
      organisationJobTitles = this.jobTitlesPipe.transform(this.data.organisationJobTitles);
    }

    const organisationWithJobTitles: OrganisationWithJobTitles[] = [];
    organisationJobTitles.forEach(organisationJobTitle => {
      if (
        !!organisationWithJobTitles.find(
          organisation => organisation.organisationId === organisationJobTitle.organisationId,
        )
      )
        return;
      organisationWithJobTitles.push(organisationJobTitle);
    });

    return organisationWithJobTitles ?? [];
  }
}
